module.exports = __webpack_public_path__ + "img/Chien.c796f013.jpg";